// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import Link from "next/link";
import * as HomeStoreEn$PorterinFeature from "../../../../containers/home/domain/store/HomeStoreEn.mjs";
import * as HeaderModuleScss from "../styles/Header.module.scss";
import * as PageviewStore$PorterinFeature from "../../../../containers/fare-estimate-v1/domain/store/PageviewStore.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../../core/helpers/PublishEventsHelper.mjs";

var styles = HeaderModuleScss;

function PrimaryLinksComponent(Props) {
  var for_enterprise_link = Props.for_enterprise_link;
  var driver_partner_link = Props.driver_partner_link;
  var handleLinkClick = function (label) {
    PublishEventsHelper$PorterinFeature.publishEvents(PageviewStore$PorterinFeature.ga_header_event_prefix, HomeStoreEn$PorterinFeature.ga_header_specific_link_action, label);
  };
  return React.createElement("div", {
              className: styles["primary-link"]
            }, for_enterprise_link !== undefined ? React.createElement(Link, {
                    href: for_enterprise_link.link,
                    children: for_enterprise_link.label,
                    onClick: (function (param) {
                        handleLinkClick(for_enterprise_link.label);
                      })
                  }) : null, React.createElement(Link, {
                  href: driver_partner_link.link,
                  children: driver_partner_link.label,
                  onClick: (function (param) {
                      handleLinkClick(driver_partner_link.label);
                    })
                }));
}

var make = PrimaryLinksComponent;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
